export enum EventKind {
  alarm = 'alarm',
  ding = 'ding',
  door_activity = 'door_activity',
  door_intrusion = 'door_intrusion',
  key_access = 'key_access',
  motion = 'motion',
  on_demand = 'on_demand',
  on_demand_link = 'on_demand_link',
}

export enum EventType {
  ALARM = 'ALARM',
  ALEXA_GREETINGS = 'ALEXA_GREETINGS',
  CUSTOM_EVENT_DETECTED = 'CUSTOM_EVENT_DETECTED',
  CUSTOM_EVENT_DETECTED_ANSWERED = 'CUSTOM_EVENT_DETECTED_ANSWERED',
  DING_ANSWERED = 'DING_ANSWERED',
  DING_MISSED = 'DING_MISSED',
  DOOR_INTRUSION = 'DOOR_INTRUSION',
  KEY_ACCESS = 'KEY_ACCESS',
  KNOCK_ANSWERED = 'KNOCK_ANSWERED',
  KNOCK_MISSED = 'KNOCK_MISSED',
  MOTION = 'MOTION',
  MOTION_ANSWERED = 'MOTION_ANSWERED',
  MOTION_PERSISTENT = 'MOTION_PERSISTENT',
  MOTION_PERSON = 'MOTION_PERSON',
  MOTION_PERSON_ANSWERED = 'MOTION_PERSON_ANSWERED',
  ON_DEMAND = 'ON_DEMAND',
  ON_DEMAND_LINK = 'ON_DEMAND_LINK',
  ON_DEMAND_FLIGHT = 'ON_DEMAND_FLIGHT',
  ON_DEMAND_FLIGHT_LINK = 'ON_DEMAND_FLIGHT_LINK',
  SCHEDULED = 'SCHEDULED',
  PACKAGE_DETECTED = 'PACKAGE_DETECTED',
  PACKAGE_DETECTED_ANSWERED = 'PACKAGE_DETECTED_ANSWERED',
  QUICK_REPLIES = 'QUICK_REPLIES',
  LOCALLY_STORED = 'LOCALLY_STORED',
}

export enum EVENT_STATE {
  timed_out = 'timed_out',
  completed = 'completed',
}

const eventTypesLabel = {
  'answered-ring': 'Answered Ring',
  'missed-ring': 'Missed Ring',
  'answered-knock': 'Answered Knock',
  'missed-knock': 'Missed Knock',
  'key-delivery': 'Key Delivery',
  motion: 'Motion',
  'answered-motion': 'Answered Motion',
  'answered-motion-person': 'Answered Motion (Person)',
  'person-detected': 'Person Detected',
  'persistent-visitor': 'Persistent Visitor',
  'live-view': 'Live View',
  'linked-motion': 'Linked Motion',
  'linked-alarm': 'Linked Alarm',
  'door-intrusion': 'Door Intrusion',
  'alexa-greetings': 'Alexa Greetings',
  'quick-replies': 'Quick Replies',
  'package-detected-answered': 'Answered Motion (Package Detected)',
  'package-detected': 'Package Detected',
  'custom-event-detected': 'Custom Event Detected',
  'custom-event-detected-answered': 'Answered Motion (Custom Event)',
  'locally-stored': 'Locally Stored',
  'live-flight': 'Live Flight',
  'linked-flight': 'Linked Flight',
  'scheduled-flight': 'Scheduled Flight',
  'device-name-plus-path': '{{device_name}} following {{path_name}} path',
};

export const EVENT_LABEL_MATCH: Readonly<
  { [key in EventType]: Readonly<string> }
> = Object.freeze({
  [EventType.ALARM]: eventTypesLabel['linked-alarm'],
  [EventType.ALEXA_GREETINGS]: eventTypesLabel['alexa-greetings'],
  [EventType.CUSTOM_EVENT_DETECTED]: eventTypesLabel['custom-event-detected'],
  [EventType.CUSTOM_EVENT_DETECTED_ANSWERED]:
    eventTypesLabel['custom-event-detected-answered'],
  [EventType.DING_ANSWERED]: eventTypesLabel['answered-ring'],
  [EventType.DING_MISSED]: eventTypesLabel['missed-ring'],
  [EventType.KNOCK_ANSWERED]: eventTypesLabel['answered-knock'],
  [EventType.KNOCK_MISSED]: eventTypesLabel['missed-knock'],
  [EventType.DOOR_INTRUSION]: eventTypesLabel['door-intrusion'],
  [EventType.KEY_ACCESS]: eventTypesLabel['key-delivery'],
  [EventType.MOTION]: eventTypesLabel['motion'],
  [EventType.MOTION_ANSWERED]: eventTypesLabel['answered-motion'],
  [EventType.MOTION_PERSON]: eventTypesLabel['person-detected'],
  [EventType.MOTION_PERSON_ANSWERED]: eventTypesLabel['answered-motion-person'],
  [EventType.MOTION_PERSISTENT]: eventTypesLabel['persistent-visitor'],
  [EventType.ON_DEMAND]: eventTypesLabel['live-view'],
  [EventType.ON_DEMAND_FLIGHT]: eventTypesLabel['live-flight'],
  [EventType.ON_DEMAND_LINK]: eventTypesLabel['linked-motion'],
  [EventType.ON_DEMAND_FLIGHT_LINK]: eventTypesLabel['linked-flight'],
  [EventType.SCHEDULED]: eventTypesLabel['scheduled-flight'],
  [EventType.PACKAGE_DETECTED]: eventTypesLabel['package-detected'],
  [EventType.PACKAGE_DETECTED_ANSWERED]:
    eventTypesLabel['package-detected-answered'],
  [EventType.QUICK_REPLIES]: eventTypesLabel['quick-replies'],
  [EventType.LOCALLY_STORED]: eventTypesLabel['locally-stored'],
});
